import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import siteSettings from './modules/siteSettings';
import users from './modules/users';
import anomaly from './modules/anomaly';
import settings from './modules/settings';
import products from './modules/products';
import statistics from './modules/statistics';
import locked_products from './modules/locked_products';
import productLayout from './modules/productLayout';

const store = createStore({
  plugins: [createPersistedState({
    key: 'store',
    paths: 'logged'
  })],
  modules: {
    siteSettings,
    users,
    anomaly,
    settings,
    products,
    statistics,
    locked_products,
    productLayout
  }
});

export default store;